import { SessionSorageInstance } from "../SessionStorageService";

export const headers = () => {
    return {'Authorization': SessionSorageInstance.getToken()}
};

export const extendHeaders = () => {
    return {
        'Authorization': SessionSorageInstance.getToken(),
        "Content-type": "application/json"    
    }
};

export const baseUrl = process.env.REACT_APP_BASE_URL as string;
